module.exports = __webpack_public_path__ + "img/trial.cb7d6f91.png";